import { crudRequest, crudRequestGet } from '@/services/api';

const params = {
  provinceArea: '',
  routeName: '',
  routePath: '',
  period: ['工作日', '周六', '周日'],
  version: '',
};
export default {
  namespace: 'routelineratiotime',
  state: {
    searchParams: { ...params },
    page: 1,
    pageSize: 20,
    total: 0,
    dataList: [],
    versionOption: [], // 版本号列表
  },

  effects: {
    *getData({ payload }, { call, put, select }) {
      const { searchParams, page, pageSize } = yield select(
        ({ routelineratiotime }) => routelineratiotime,
      );
      const { provinceArea, routeName, routePath, version, period } = searchParams;
      const param = {
        // ...searchParams,
        routeName,
        routePath,
        id: version,
        page: payload?.page || page,
        pageSize,
        provinceArea: provinceArea?.name,
        period: period?.toString(),
      };
      const data = yield crudRequest(
        '/api/route/trunkLineController/getPageList',
        param,
        { reqType: null, module: 'basic' },
        // 'content-type': 'application/x-www-form-urlencoded'
      );
      if (data && data.code === 1 && data.data) {
        const dataList = data.data?.rows?.map((m, key) => ({ ...m, key })) ?? [];
        yield put({
          type: 'updateState',
          payload: { dataList, page: param.page, total: Number.parseInt(data.data.total) },
        });
      }
    },
    *getVersion(_, { call, put, select }) {
      const data = yield crudRequestGet('/api/route/trunkLineController/getVersionList', {
        module: 'basic',
      });
      if (data && data.code === 1 && data.data && data.data.data[data.data.index]) {
        data.data.data[data.data.index].optionName = '当前生效版本';
        const currentVersionId = data.data.data[data.data.index].id;
        yield put({
          type: 'updateState',
          payload: {
            versionOption: data.data.data || [],
            searchParams: { ...params, version: currentVersionId },
          },
        });
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      const searchParams = { ...state.searchParams, ...payload };
      return { ...state, searchParams };
    },
  },
};
